import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { FaqService } from '@services/faq.service';
import{ NavigationService } from '@services/navigation.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';

@Component({
  selector: 'app-faq-pay-in-full',
  templateUrl: './faq-pay-in-full.component.html',
  styleUrls: ['./faq-pay-in-full.component.scss'], 
  imports: [TranslatePipe, RouterLink, CommonModule, MdbRippleModule],
  schemas: [NO_ERRORS_SCHEMA]
})
export class FaqPayInFullComponent{
  accordianWithMDB: any = {};
  isSimplifiedPayPlan = false;

  constructor(
    private faqService: FaqService,
    private navService: NavigationService,
    private policyDataService: PolicyDataService
  ) {
    this.accordianWithMDB = this.faqService.getAccordianWithMDB();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
          if (policyResponse && policyResponse.length > 0) {
            const policy = policyResponse.find((pol) => pol.isSimplifiedPayPlan);
            this.isSimplifiedPayPlan = policy?.isSimplifiedPayPlan;
          }    
        });
  }

  closeNonActiveCollapse(name): void {
    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

  onClickBack(){
    this.navService.navigateBack();
  }
}
